module.exports = __webpack_public_path__ + "static/media/busy-hives.0ac4d491.png";